
<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          گزارش‌ها
        </CCardHeader>
        <CCardBody class="d-flex align-items-center text-center h-100">
          <CDataTable
              class="
              w-100
              d-flex
              flex-column
              justify-content-between
              align-items-end
              h-100
            "
              :noItemsView="{
              noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
            }"
              :items="report"
              :fields="fields"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
          >
            <template #reportView="{ item }">
              <td>
                <CButton
                    square
                    class="modal-button px-4"
                    size="md"
                    @click="onViewReportModal(item)"
                >
                مشاهده
                </CButton>
              </td>
            </template>

          </CDataTable>
          <ViewReportModal v-model="viewReportModal" :report="selectedItem" />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import ViewReportModal from "@/components/Modals/Report/ViewReportModal";
export default {
  components: {
    ViewReportModal
  },
  name: "report",
  data() {
    return {
      report: [],
      loading: false,
      fields: [
        {key: "name", label: "نام گزارش"},
        {key: "reportView", label: "نمایش"},
      ],
      selectedItem: null,
      viewReportModal: false,
    };
  },
  computed: {
    computedReport() {
      return this.report.map((item) => {
        return {
          ...item,
        };
      });
    },
  },
  mounted() {
    this.getReport();
  },
  methods: {
    async getReport() {
      try {
        this.loading = true;
        const {data} = await axios.get("/report");
        this.report = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onViewReportModal(item) {
      this.selectedItem = item
      this.viewReportModal = true
    },
  },

};
</script>

<style lang="scss" scoped></style>
